import { Grid3x3 } from 'lucide-react';
import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type ApplianceFeatureParams = FeatureHoookParams;
export const useShowGridFeature = (_params: ApplianceFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { viewport: { updateConfig:(config: { showGrid: boolean }) => void, config: {showGrid: boolean }}}>();

	useSubscription(controller, false, [['viewport-config', 'updated']]);

	const controllerSupportsFeature = (controller?.viewport?.config?.showGrid ?? null) !== null;
	const showGrid = controller?.viewport?.config?.showGrid ?? false;

	const tooltip = (() => {
		return showGrid ? lang.view.tooltip.hideGrid : lang.view.tooltip.showGrid;
	})();

	return {
		name: 'showGrid',
		label: lang.view.label.toggleGrid,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <Grid3x3 color={controllerSupportsFeature && showGrid ? 'green' : 'black'} {...props} />,
		disabled: !controllerSupportsFeature,
		value: showGrid,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.viewport.updateConfig({ showGrid: !showGrid });
			}
		}
	};
};
